import Vue from "vue";
import JQuery from "jquery";
const $ = JQuery;

import App from "./App.vue";
import router from "./router";
import "./registerServiceWorker";

Vue.config.productionTip = false;

new Vue({
  router,
  data: {
    isLoaded: false,
  },
  mounted: function() {
    this.setTitle(this.$route.path);
    this.isLoaded = true;
  },
  watch: {
    $route: function(to, from) {
      this.setTitle(to.path);
    }
  },
  methods: {
    setTitle: function(slug) {
      if (slug == "/" || slug == "/index.html") {
        document.title = "Ollie Murphy's Personal Site";
      } else if (slug == "/portfolio") {
        document.title = "Ollie Murphy's Portfolio";
      } else if (slug == "/about") {
        document.title = "About Ollie Murphy";
      } else if (slug == "/resume") {
        document.title = "Ollie Murphy's Resumé";
      } else if (slug == "/portfolio/zverg") {
        document.title = "Case Study - Zverg";
      } else if (slug == "/portfolio/upwork") {
        document.title = "Client Reviews from Upwork";
      } else if (slug == "/portfolio/cravely") {
        document.title = "Case Study - Cravely";
      }
    },
  },
  render: h => h(App)
}).$mount("#app");
